module.exports = __webpack_public_path__ + "static/media/01.2c7b4d47.jpg";